import { IonButton, IonCard, IonChip, IonContent, IonDatetime, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonList, IonModal, IonRadio, IonRadioGroup, IonRow } from '@ionic/react'
import dayjs from 'dayjs';
import { caretDown, caretUp, refresh } from 'ionicons/icons';
import React, { useRef, useEffect, useState } from 'react'
import { SafetyPadding } from '../../components/SafetyPadding';
import Api from '../../services/Api';

interface ComponentProps {
  start: string
  recurring: Array<any> | null |undefined
  interval?: string
  handleRepeat: Function
  handleStart: Function
  repeatOption: string
  setRepeatOption: React.Dispatch<React.SetStateAction<string>>
  slideNext: Function
  cancelCreate: Function
  invited_persons: Array<number>
}

interface rangeInterface {
  start: string | string[] | null | undefined
  end: string | string[] | null | undefined
}

const CreateRepeat = ({ start, invited_persons, recurring, handleRepeat, setRepeatOption, slideNext, cancelCreate} : ComponentProps) => {
  const api = Api.getInstance()
  const datetime = useRef<null | HTMLIonDatetimeElement>(null);
  const today = dayjs().format('YYYY-MM-DDTHH:mmZ')
  const [repetition, setRepetition] = useState('custom')
  const [recurringArr, setRecurringArr] = useState<Array<any>>([])
  const [range, setRange] = useState<rangeInterface>({
    start: '' as string | string[] | null | undefined,
    end: '' as string | string[] | null | undefined
  })
  const [timeOpen, setTimeOpen] = useState(false)
  const [showActionSheet, setShowActionSheet] = useState(false)
  const [time, setTime] = useState<string | string[] | null | undefined>('')
  const [startSet, setStartSet] = useState(false)
  const [endSet, setEndSet] = useState(false)
  const [number, setNumber] = useState<string | undefined | null>('1')

  const usePrevious = (value: any) => {
    const ref: React.MutableRefObject<rangeInterface | any> = React.useRef();
    useEffect(() => {
      ref.current = value;
    }, [value])

    return ref.current;
  }

  const prevRange: rangeInterface = usePrevious(range)
  const prevRecurringArr = usePrevious(recurringArr)
  const prevRepetition = usePrevious(repetition)
  
  useEffect(() => {
    if((recurring !== undefined && recurring !== null) && recurring!.length > 0) {
      const isoArr = recurring.map((date) => new Date(date.start).toISOString())
      if(!datetime.current) return
      datetime.current.value = isoArr
    } else {
      if(!datetime.current) return
      datetime.current.value = [new Date(today).toISOString()]
    }
  }, [])

  useEffect(() => {
    if(recurring!.length !== recurringArr.length) {
      setRecurringArr(recurring!.map((date) => new Date(date.start).toISOString()))
    }
  }, [recurring])

  useEffect(() => {
    if(recurringArr.length > 0 && recurringArr !== prevRecurringArr) {
      const newArr = recurringArr.map(obj => {
        let test = dayjs(obj).set('hour', parseInt(dayjs(time as string).format('HH'))).set('minute', parseInt(dayjs(time as string).format('mm'))).format('YYYY-MM-DD HH:mm')
        const persons_inv = invited_persons.length > 0 ? invited_persons : []
        return {
          start: test, 
          invited_persons: persons_inv
        }
      })
      handleRepeat(newArr.length > 0 ? newArr : [{start: [], invited_persons: []}])
    }
  }, [recurringArr])

  useEffect(() => {
    if(repetition !== prevRepetition){
      datesFromCal()
    } else {
    }
  }, [repetition])

  useEffect(() => {
    if(prevRange) {
      if((range.start !== prevRange.start) || (range.end !== prevRange.end)){
        checkRepetition()
      } else if(range !== prevRange){
        checkRepetition()
        if(recurringArr !== prevRecurringArr){
          // console.log('recarr', recurringArr, prevRecurringArr)
        }
      } else {
        // console.log('Range: no change',range, prevRange)
      }
    }
  }, [range])

  useEffect(() => {
    checkRepetition()
  }, [number])

  useEffect(() => {
    if(start && start !== 'Invalid Date') {
      setRange({...range, start: dayjs(start).format('YYYY-MM-DDTHH:mmZ')})
      setTime(dayjs(start).format('YYYY-MM-DDTHH:mmZ'))
    } else {
      setTime(today)
    }
  }, [start])

  const checkRepetition = () => {
    const day = new Date(range.start as string)
    const end = new Date(range.end as string)

    if(startSet && endSet) {
      if(repetition === 'daily') {      
        dailyRepetition(day, end);
      } else if(repetition === 'weekdays') {
        weekdayRepetition(day, end)
      } else if(repetition === 'custom') {
        // customRepetition()
      } else if(repetition === 'weekly' || repetition === 'monthly') {
        if(repetition === 'weekly') {
          weeklyRepetition(day, end)
        } else if(repetition === 'monthly') {
          monthlyRepetition(day, end)
        } 
      } else if(repetition === 'none'){
        
      }
    } else if(repetition === 'weekly' || repetition === 'monthly') {
      if(repetition === 'weekly') {
        weeklyRepetition(day, end)
      } else if(repetition === 'monthly') {
        monthlyRepetition(day, end)
      } 
    }
  }

  const dailyRepetition = (startDate: Date, endDate: Date) => {
    const date = new Date(startDate.getTime());
    const dates = []
    while (date <= endDate) {
      dates.push(dayjs(new Date(date)).format('YYYY-MM-DDTHH:mmZ'))

      date.setDate(date.getDate() + 1);
    }
    setRecurringArr(dates)
    return dates;
  }

  const weeklyRepetition = (startDate: Date, endDate: Date) => {
    const date = new Date(startDate.getTime());
    const dates = [];
    for(let i = 0; parseInt(number as string) > i; i++) {
      dates.push(dayjs(date).add(i,'week').format('YYYY-MM-DDTHH:mmZ'))
    }
    setRecurringArr(dates)
    return dates;
  }

  const monthlyRepetition = (startDate: Date, endDate: Date) => {
    const date = new Date(startDate.getTime());
    const dates = []

    for(let i = 0; parseInt(number as string) > i; i++) {
      dates.push(dayjs(new Date(date)).add(i,'month').format('YYYY-MM-DDTHH:mmZ'))
    }
    
    setRecurringArr(dates)
    return dates;
  }

  const weekdayRepetition = (startDate: Date, endDate: Date) => {
    const date = new Date(startDate.getTime());
    const dates = [];
  
    while (date <= endDate) {
      if(dayjs(date).day() <= 5 && dayjs(date).day() !== 0) {
        dates.push(dayjs(new Date(date)).format('YYYY-MM-DDTHH:mmZ'));
      }
      date.setDate(date.getDate() + 1);
    }
    setRecurringArr(dates)
    return dates;
  }

  const repetitionValue = () => {
    let value = ''

    if(repetition === 'none') {
      value = api.tr('Walking_DontRepeat')
    } else if(repetition === 'custom'){
      value = api.tr('frequency_choice1')
    } else if(repetition === 'daily'){
      value = api.tr('frequency_choice2')
    } else if(repetition === 'weekly'){
      value = api.tr('frequency_choice3')
    } else if(repetition === 'monthly'){
      value = api.tr('frequency_choice4')
    } else if(repetition === 'weekdays'){
      value = api.tr('frequency_choice5')
    }
    return value
  }

  const datesFromCal = () => {
    let startDate = today
    let endDate = today
    const sortedArr = sortDates()
    const last = sortedArr.length - 1

    if(sortedArr.length === 1) {
      startDate = sortedArr[0]
      setStartSet(true)
    } else if (sortedArr.length >= 2) {
      endDate = sortedArr[0]
      startDate = sortedArr[last]
      setStartSet(true)
      setEndSet(true)
    }
    setRange({
      start: new Date(startDate).toISOString(), 
      end: new Date(endDate).toISOString()
    })
  }

  const sortDates = () => {
    return recurringArr.sort((a, b) => {
      return new Date(b).getDate() - new Date(a).getDate()
    })
  }
  
  return (
    <IonContent>
      <h2 className="color_blue flex items-center justify-center m-2 mt-6">
        <IonChip color="darkblue" slot="start" className="circle_small flex justify-center items-center mr-2">1</IonChip>
        {/* {api.tr('frequency_choice')} */}
        Use the calendar to pick dates
      </h2>           
      <IonList>
      {/* <IonCard className="p-2 m-2" onClick={() => setShowActionSheet(true)}>
        <IonItem lines="none">
          <IonLabel>
            {api.tr('frequency_amount')}
          </IonLabel>
          {repetitionValue()}
          <IonIcon size="small" icon={showActionSheet ? caretUp : caretDown}/>
        </IonItem>
      </IonCard> */}
      { repetition === 'weekly' || repetition === 'monthly' ? 
      <>
        <h2 className="color_blue flex items-center justify-center m-2 mt-6">
          <IonChip color="darkblue" slot="start" className="circle_small flex justify-center items-center mr-2">2</IonChip>
          {api.tr('set_frequency_repetition')}
        </h2>
        <IonCard className="p-2 m-2">
          <IonItem lines="none">
            <IonLabel>
              {api.tr('number_of')}
            </IonLabel>
            <IonInput value={number} type="number" onIonChange={(e) => setNumber(e.detail.value)}/> 
          </IonItem>
        </IonCard>
      </> 
      : null }
        <IonRow className="flex justify-end items-center"> 
          { repetition !== 'custom' ? 
          <IonButton 
            className="m-2"
            onClick={() => datesFromCal()}>
            <IonIcon icon={refresh}  />
          </IonButton>
          : null }
          <IonButton 
            className="m-2"
            onClick={() => {
            setRecurringArr([new Date(today).toISOString()])
            datetime.current!.value = [new Date(today).toISOString()]
            }}>Reset
          </IonButton>
        </IonRow>
      </IonList>
      <IonGrid >
        <IonRow className="flex justify-center">
          <IonDatetime
            min={new Date(today).toISOString()}
            firstDayOfWeek={1}
            color="teal"
            presentation="date"
            multiple
            ref={datetime}
            onClick={() => {              
              if(repetition !== 'custom' && recurringArr.length > 2) {
                setRepetition('custom')
              }
            }}
            onIonChange={(e) => {
              const convertStringToArray = (object: string | string[] | null | undefined) => {
                return (typeof object === 'string') ? Array(object) : object
              }
              const arr = convertStringToArray(e.detail.value) as Array<any>
              
              setRecurringArr(arr.map(date => new Date(date).toISOString()))
            }
          }/>
        </IonRow>
        <IonRow className="flex flex-col items-center justify-center">
          <h2 className="color_blue m-2">{api.tr('StartingTime_of_walk')}</h2>
          {/* <IonDatetimeButton color="teal" datetime="datetimetime" /> */}
          <IonButton onClick={() => setTimeOpen(true)}>
            {dayjs(time as string).format('HH:mm')}
          </IonButton>
        </IonRow>
        <IonRow>
        { recurring && recurring.length > 0 ?
          recurring.map((day: any, key: any) => <IonItem key={key} className="fullWidth p-2">
            <IonLabel>{dayjs(day.start).format('dddd DD MMMM')} {api.tr('StartingTime_of_walk')} {dayjs(time as string).format('HH:mm')}</IonLabel>
          </IonItem>)
        : 
        null
       }
        </IonRow>
      </IonGrid>                          
      <IonModal keepContentsMounted isOpen={timeOpen} onDidDismiss={() => setTimeOpen(false)}>
        <IonDatetime 
          showDefaultButtons
          // firstDayOfWeek={1}
          id="datetimetime" 
          presentation="time"
          value={dayjs(time as string).format('YYYY-MM-DDTHH:mmZ')}
          onIonChange={(e) => {
            setTime(e.detail.value)
          }}/>
      </IonModal>
      <IonModal
        initialBreakpoint={0.50} breakpoints={[0, 0.25, 0.5, 0.75]}
        isOpen={showActionSheet}
        onDidDismiss={() => setShowActionSheet(false)}>
        <IonRadioGroup 
          value={repetition} 
          onIonChange={(e) => {
            setRepetition(e.detail.value)
            setRepeatOption(e.detail.value)
          }}>
          <IonItem>
            <IonLabel className="m2-2">
              {api.tr('Walking_DontRepeat')}
            </IonLabel>
            <IonRadio slot="end" value='none'/>
          </IonItem>
          <IonItem>
            <IonLabel className="m2-2">
              {api.tr('frequency_choice2')}
            </IonLabel>
            <IonRadio slot="end" value='daily'/>
          </IonItem>
          <IonItem>
            <IonLabel className="m2-2">
              {api.tr('frequency_choice3')}
            </IonLabel>
            <IonRadio slot="end" value='weekly'/>
          </IonItem>
          <IonItem>
            <IonLabel className="m2-2">
              {api.tr('frequency_choice4')}
            </IonLabel>
            <IonRadio slot="end" value='monthly'/>
          </IonItem>
          <IonItem>
            <IonLabel className="m2-2">
              {api.tr('frequency_choice5')}
            </IonLabel>
            <IonRadio slot="end" value='weekdays'/>
          </IonItem>
          <IonItem>
            <IonLabel className="m2-2">
              {api.tr('frequency_choice1')}
            </IonLabel>
            <IonRadio slot="end" value='custom'/>
          </IonItem>
        </IonRadioGroup>
      </IonModal>
      <IonRow className="mt-6">
          <IonButton 
            onClick={() => slideNext()}
            expand="block" 
            className="m-2 fullWidth">
            {api.tr('ContinueNext_page')}
          </IonButton>
        </IonRow>
        <IonRow>
          <IonButton 
            onClick={() => {
              cancelCreate()
            }}
            expand="block" 
            fill="clear"
            className="m-2 fullWidth">
            {api.tr('cancel')}
          </IonButton>
        </IonRow>
      <SafetyPadding/>
    </IonContent>
  )
}

export default CreateRepeat